import React, { Dispatch, FC, SetStateAction } from 'react';

import { StyledEmoji } from 'components/UI/Emoji/styled';
import { ReactComponent as PlusIcon } from 'assets/icons/Plus.svg';
import { useSendReaction } from 'graphQL/reactions/hooks';

import { StyledReaction } from './styled';

interface IReactionButtonProps {
  emoji?: string;
  isPlus?: boolean;
  isEmojiOnly?: boolean;
  handleClick?: () => void;
  setIsQuickReactionOpen?: Dispatch<SetStateAction<boolean>>;
}

const ReactionButton: FC<IReactionButtonProps> = ({
  emoji,
  isPlus,
  isEmojiOnly,
  handleClick,
  setIsQuickReactionOpen,
}) => {
  const sendReaction = useSendReaction(emoji);

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (emoji) {
      sendReaction();
    }
    handleClick?.();
    setIsQuickReactionOpen?.(false);
  };

  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return isEmojiOnly ? (
    <StyledEmoji onClick={onClick} onMouseDown={onMouseDown}>
      {emoji}
    </StyledEmoji>
  ) : (
    <StyledReaction onClick={onClick} onMouseDown={onMouseDown}>
      {isPlus ? <PlusIcon /> : <StyledEmoji>{emoji}</StyledEmoji>}
    </StyledReaction>
  );
};

export default ReactionButton;
